module.exports = __webpack_public_path__ + "static/images/work.3Zl7ndh.svg";